import { NgModule } from "@angular/core";
import { ContractAccessRequestConfirmationComponent } from "./contract-access-request-confirmation.component";
import { SharedModule } from "src/app/modules/shared.module";
import { CommonModule } from "@angular/common";
import { ContractsModule } from "../../contracts.module";

@NgModule({
    declarations: [ContractAccessRequestConfirmationComponent],
    imports: [ SharedModule, CommonModule ],
    exports: [ ContractAccessRequestConfirmationComponent ],
    providers: []
})

export class ContractAccessRequestConfirmationModule {}